import moment from "moment";

export default function(dateFrom, dateTo, key) {
  return moment(dateTo).diff(moment(dateFrom), key);
}